import $ from 'jquery';
import pageScripts from './pages';

import 'what-input';

require( './components/objectfitimages' );

$( document ).ready( function () {
	//Require all components here.
	require( './components/search' );
	require( './components/recently-viewed-products' );
	require( './components/featured-products' );
	require( './components/menu-dropdown' );
	require( './components/also-bought');
	require( './product/quickview' );
	require( './product/item' );
	require( './product/quantity' );

	if ( $( '.has-tip' ).length ) {
		import( './components/tooltip' );
	}

	if ( $( '.product-sorting' ).length ) {
		import( './product/sorting' );
		import( './product/back-to-top' );
	}

	if ( $( '.product-filters' ).length ) {
		import( './product/filters' );
	}

	if ( anssems_shop.is_trailer_category_page === 'no' && $( '.product-overview-block' ).length ) {
		import('./components/product-overview-block');
	}

} );

document.body.className.replace( /-/g, '_' ).split( /\s+/ ).forEach( cls => {
	pageScripts[ cls ] && pageScripts[ cls ]();
} );
